module.exports = __webpack_public_path__ + "img/usa.fc7b7c60.png";